// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router' 
import firebase from 'firebase/app'
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';

// Notification
import Notifications from 'vue-notification'
Vue.use(Notifications)

// Vue Tour
import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

// Google Fonts
var WebFont = require('webfontloader');

Vue.config.productionTip = false

// Global progress bar
import VueProgressBar from 'vue-progressbar'

Vue.use(VueProgressBar, {
  color: '#f4c20d',
  failedColor: 'red',
  thickness: '3px',
  transition: {speed: '0.1s', opacity: '0.6s', termination: 400}
})

// Global Vue Workers (web workers)
import VueWorker from 'vue-worker'
Vue.use(VueWorker)

// Vue Slider
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.component('VueSlider', VueSlider)

// Globals
let globalImages = getImages();
let globalMarks = getMarks();
let globalSessionInfo = getSessionInfo();

function getImages() {
  return {
    uploadedImages: []
  }
}

function getMarks() {
  return {
    savedMarks: []
  }
}

function getSessionInfo() {
  return {
    isLoading: {},
    currentUser: {}
  }
}

Vue.mixin({
  data() {
    return { globalImages, globalMarks, globalSessionInfo }
  },
  methods: {
    testFunction: function() {
    }
  }
})

//
// Firebase Integration
//

var config = {
  apiKey: "AIzaSyBQA5ku31G1Knv-V88y5UW6hPYXqSrDv7A",
  authDomain: "app.watermarks.io",
  databaseURL: "https://wm-app-3ca35.firebaseio.com",
  projectId: "wm-app-3ca35",
  storageBucket: "wm-app-3ca35.appspot.com",
  messagingSenderId: "676559300512"
};
firebase.initializeApp(config);

// User Info
// user has Observer object on Auth object which is stored as a ref in globalSessionInfo below
firebase.auth().onAuthStateChanged(function(){
  
  let currentUser = firebase.auth().currentUser;
  
  // logged in
  if (currentUser) {
      if (currentUser.isAnonymous) {        
        Vue.set(globalSessionInfo.currentUser, 'isLoggedIn', false) // treat anonymous users as logged out! they can provide feedback / stats 
        Vue.set(globalSessionInfo.currentUser, 'isAnonymous', currentUser.isAnonymous);
      } else {
        // set user information 
        Vue.set(globalSessionInfo.currentUser, 'isLoggedIn', true);
        Vue.set(globalSessionInfo.currentUser, 'isAnonymous', currentUser.isAnonymous);
        Vue.set(globalSessionInfo.currentUser, 'userId', currentUser.uid);
        Vue.set(globalSessionInfo.currentUser, 'displayName', currentUser.displayName);
        Vue.set(globalSessionInfo.currentUser, 'photoURL', currentUser.photoURL);
        // display spinner
        Vue.set(globalSessionInfo.isLoading, 'templates', true)
        // refresh watermarks now that user is logged in
        let userId = currentUser.uid
        refreshWatermarks(userId)
      }

  // logged out
  } else {
      // No currentUser is signed in.
      Vue.set(globalSessionInfo, 'currentUser', {})
      Vue.set(globalSessionInfo.currentUser, 'isLoggedIn', false)
      Vue.set(globalMarks, 'savedMarks', [])
  }
});  

// keeping wm refresh in main.js to watch statechange and let firestore update
function refreshWatermarks(userId) {
  // display spinner
  Vue.set(globalSessionInfo.isLoading, 'templates', true)    

  // Watch changes in watermarks
  const marksRef = firebase.firestore().collection('watermarks').doc(userId).collection('marks')  

  marksRef.onSnapshot(function(querySnapshot) {
    // remove all marks
    globalMarks.savedMarks = []
    // reload all marks
    querySnapshot.forEach(function(doc) {
      globalMarks.savedMarks.push(doc.data())
    });
    // loading complete (below)
    Vue.set(globalSessionInfo.isLoading, 'templates', false)      
    loadFonts() // this will duplicate google fonts html tags in header each time it runs
  })
}

function loadFonts() {
  var fontList = []
  // add all fonts to list (some marks have more than one font)
  globalMarks.savedMarks.forEach(tempMark => {
    tempMark.fontProperties.forEach(font => {
      fontList.push(font.fontFamily)
    })
  })
  
  // use google's webfontloader to load fontList
  WebFont.load({
    google: {
      families: fontList
    }
  })  
}




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  data() {
    return {
    }
  },
  mounted() {
    // if user logged in, refresh templates every time app is reloaded
    if (this.globalSessionInfo.currentUser.isLoggedIn) {currentUserrefreshWatermarks()}
  }
})

